import { mockConfig } from './common-config';

export const environment = {
  ...mockConfig,
  production: false,
  endpoint: 'https://api-qa.trucklots.com/api/v1/',
  notificationEndPoint: 'https://api-qa.trucklots.com/bookings',
  videoUrlLink: 'https://trucklotsqastorage.blob.core.windows.net/public-data/',
};
